import React, { useEffect, useState } from "react"
import styles from "./index.module.css";
import { Button, Grid, Typography, InputBase,useMediaQuery } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import ProfileScreen from '../../../Profile';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import HttpHeader from '../../../../header';
import { Field, FieldProps, Form, Formik } from 'formik';
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import AddressPicker from '../../../AddressPicker/AddressPicker';
import { ApolloError, useLazyQuery, useMutation } from '@apollo/client';
import { useSnackBar } from '../../../SnackBarContext/SnackBarContext';
import { SnackBarVariant } from '../../../SnackbarWrapper/SnackbarWrapper';
import { formatGraphQLErrorMessage } from '../../../utils';
import { UPDATE_BUSINESS_CUSTOMER } from '../../../../graphql/user/updateUser';
import * as Yup from "yup";
import { BusinessCustomerStatus, UserRole } from '../../../../reducers/auth/types';
import { GET_CONSUMER_DASHBOARD_DATA } from "../../../../graphql/dashboard/getConsumerDashboardDataQuery";
import InvoiceBalanceCard from "./InvoiceBalanceCard";


const StyledInput = withStyles(() =>
  createStyles({
    root: {
      border: "1px solid #c0c0c0",
      borderRadius: 6,
      padding: "8px 10px",
      marginTop: 5,
      '&.Mui-focused': {
        borderColor: "var(--primary-color)"
      },
      '&.Mui-error': {
        borderColor: "#D13135",
        color: "#D13135"
      }
    },
  }),
)(InputBase);

interface IDashboardData {
  invoicesBalance: IinvoicesBalance;
  activeBookings: number;
  activeVehicles: number;
}

export interface IinvoicesBalance {
  sundryInvoiceAmountDue: number
  totalAmountDue: number
  totalInvoicesDue: number
  unpaidSundryInvoices: number
}

const PortalDashboard = () => {
  const [data, setData] = useState<IDashboardData>()
  const user = useSelector((state: IAppState) => state.authReducer.user);

  const [getDashboardData,{ loading }] = useLazyQuery(GET_CONSUMER_DASHBOARD_DATA, {
      fetchPolicy: "network-only",
      onCompleted(data) {
        setData(data.consumerDashboardData)
      },
    });

  useEffect(() => {
    getDashboardData({
      variables: {
        businessCustomerId: user?.businesscustomers?.id || undefined
      }
    });
  }, []);
  
  return (
    <>
    <div className={styles.column}>
      <Typography variant="h2" className="semi-bold">
        Dashboard
      </Typography>
    </div>
    <div className={styles.row}>
      <InvoiceBalanceCard data={data?.invoicesBalance} />
      <div className={styles.box} style={{marginLeft: 20}}>
        <Typography variant="h4">Active Vehicles Count</Typography>
          <div className="flex fill cross-end">
            <div className="padding-right" style={{ marginTop: 25}}>
              <Typography variant="body1" className="opacity50">Total active Bookings</Typography>
              <Typography variant="h3" className="bold">{data?.activeBookings}</Typography>
            </div>
            <div className="margin-left padding-left">
              <Typography variant="body1" className="opacity50">Total Vehicles</Typography>
              <Typography variant="h3" className="bold" >{data?.activeVehicles}</Typography>
            </div>
          </div>
      </div>
    </div>
    </>
  )
}

export default PortalDashboard